import type { GameManifest } from '@pixelworld/game-core/client';
import { ADVENTURE_ISLAND_ID, MAX_PLAYERS } from './shared/constants';

export const adventureIslandManifest: GameManifest = {
  id: ADVENTURE_ISLAND_ID,
  title: 'Adventure Island',
  tagline: 'Udforsk øen sammen med dine venner',
  minPlayers: 1,
  maxPlayers: MAX_PLAYERS,
};
